import { useAcceptNewTerm } from '../../hooks/user/use-accept-new-terms'

export const ValidateUserTerms: React.FC = () => {
  useAcceptNewTerm()
  return null
}
